import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import { ScCheckboxFormInput } from '@innogy/sitecore-forms/models';
import type { FormState } from 'ngrx-forms';
import { CheckboxComponent } from '@innogy/common-ui/forms';
import { GenericRichTextDirective } from '@core/jss-utils';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-sc-checkbox[control][fields][trackStep]',
  templateUrl: './sc-checkbox.component.html',
  standalone: true,
  imports: [CheckboxComponent, GenericRichTextDirective, JssModule],
})
export class ScCheckboxComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control!: FormState<string> | FormState<boolean>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScCheckboxFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
}
